import constants from "./constants";
import { store } from "react-notifications-component";
import { closeSnackbar, SnackbarContent } from "notistack";
export function getDeviceVersion() {
	return window.innerWidth > 1024 ? 'pc' : window.innerWidth <= 1024 && window.innerWidth >= 576 ? window.innerHeight < 576 ? 'mobile-landscape' :
		'tablet' : 90 === window.orientation ? 'mobile-landscape' : 'mobile';
}

export function formatDecimalNotRound(t) {
	var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ""
		, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 6
		, a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
		, i = parseFloat(t.toString().replace(",", "") || 0).toFixed(8)
		, o = ("" + ((i = parseFloat(i)) || e)).split(".");
	if (1 === o.length) {
		if (a) {
			for (var r = "", s = 0; s < n; s++)
				r += "0";
			return o[0] ? o[0] + "." + r : Number(o[0])
		}
		return Number(o[0])
	}
	if (a) {
		if (o[1].length < n) {
			for (var l = n - o[1].length, d = 0; d < l; d++)
				o[1] = o[1] + "0";
			return o[0] + "." + o[1].substr(0, n)
		}
		return o[0] + "." + o[1].substr(0, n)
	}
	return Number(o[0] + "." + o[1].substr(0, n))
}

export function getDeviceInfo() {
	return {
		deviceHeight: window.innerHeight,
		deviceWidth: window.innerWidth,
		deviceVersion: getDeviceVersion()
	};
}

export function getCurrentRoute() {
	let pathname = window.location.pathname || '';
	if (pathname.includes('register')) {
		return constants.ROUTE.REGISTER;
	}
	if (pathname.includes('login')) {
		return constants.ROUTE.LOGIN;
	}
	if (pathname.includes('forgot-password')) {
		return constants.ROUTE.FORGOT_PASSWORD;
	}
	if (pathname.includes('trading')) {
		return constants.ROUTE.TRADING;
	}
	if (pathname.includes('wallet-main')) {
		return constants.ROUTE.WALLET_MAIN;
	}
	if (pathname.includes('wallet')) {
		return constants.ROUTE.WALLET;
	}
	if (pathname.includes('profile')) {
		return constants.ROUTE.PROFILE;
	}
	if (pathname.includes('dashboard')) {
		return constants.ROUTE.DASHBOARD;
	}
	if (pathname.includes('affiliate')) {
		return constants.ROUTE.AFFILIATE;
	}
	if (pathname.includes('deposit')) {
		return constants.ROUTE.DEPOSIT;
	}
	if (pathname.includes('transfer')) {
		return constants.ROUTE.TRANSFER;
	}
	if (pathname.includes('agency')) {
		return constants.ROUTE.AGENCY;
	}
	if (pathname.includes('challenge')) {
		return constants.ROUTE.CHALLENGE;
	}
	if (pathname.includes('notification')) {
		return constants.ROUTE.NOTIFICATION;
	}
	return constants.ROUTE.HOME;
}

export function isCurrentRoute(route) {
	return getCurrentRoute() === route;
}

export function getCurrentWrapperClass() {
	switch (getCurrentRoute()) {
		case constants.ROUTE.REGISTER: return 'Register';
		case constants.ROUTE.LOGIN: return 'Login';
		case constants.ROUTE.FORGOT_PASSWORD: return 'Forgot Password';
		case constants.ROUTE.PROFILE: return 'Profile';
		case constants.ROUTE.DASHBOARD: return 'trade_history';
		case constants.ROUTE.TRADING: return 'index';
		case constants.ROUTE.WALLET_MAIN: return 'wallet_main';
		case constants.ROUTE.WALLET: return 'binary_wallet';
		case constants.ROUTE.AFFILIATE: return 'affiliate';
		case constants.ROUTE.CHALLENGE: return 'challenge';
		case constants.ROUTE.TRANSFER: return 'transfer';
		case constants.ROUTE.AGENCY: return 'challenge agency';
		case constants.ROUTE.NOTIFICATION: return 'notification';
		default: return 'Home';
	}
}
export function formatDate(dateString) {
	const date = new Date(dateString);
	const options = {
		day: '2-digit',
		month: '2-digit',
		year: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
	};
	return new Intl.DateTimeFormat('en-GB', options).format(date).replace(',', '');
}
export function formatNumberDecimal(number) {
	const numberString = String(number);
	const cleanedString = numberString.replace(/,/g, '');
	const floatNum = parseFloat(cleanedString);
	if (isNaN(floatNum)) {
		return 'Invalid number';
	}

	// Kiểm tra xem số có phải là số tròn hay không
	if (Number.isInteger(floatNum)) {
		return new Intl.NumberFormat('en-US').format(floatNum);
	}

	// Định dạng số với phần thập phân nếu không phải là số tròn
	return new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(floatNum);
}
export function formatDMY(dateString) {
	const date = new Date(dateString);
	const options = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	};
	return new Intl.DateTimeFormat('en-GB', options).format(date).replace(',', '');
}
export function formatNumber(value) {
	return (value || '0').toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
function isHTMLString(str) {
	const doc = new DOMParser().parseFromString(str, 'text/html');
	return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}
export function showNotification(enqueueSnackbar, options) {
	let durationDismiss = options?.dismiss?.duration || (options.message || '').length * 100;
	if (durationDismiss < 5000) {
		durationDismiss = 5000;
	}
	if (durationDismiss > 60000) {
		durationDismiss = 60000;
	}
	enqueueSnackbar('', {
		variant: options.type || 'success',
		autoHideDuration: 3000,
		anchorOrigin: {
			vertical: 'top',
			horizontal: 'right',
		},
		content: (key) => (
			<div className="z-custom" 
			>
				<div style={{ marginRight: '20px' }}>
					<div className="position-relative min-w-[200px] bg-secondary-600 text-light rounded-[5px] border border-success/10">
						<div className="py-[13.5px] px-5">
							<div className="d-flex align-items-center">
								<div>
									{options.type === 'success' && <span className="rounded-full d-inline-flex w-[31px] h-[31px] algin-items-center justify-content-center bg-success">
										<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-prefix="fas" data-icon="check" role="img" viewBox="0 0 512 512" className="w-[16px]">
											<path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z">
											</path>
										</svg>
									</span>}
									{options.type === 'danger' && <span className="rounded-full d-inline-flex w-[31px] h-[31px] align-items-center justify-content-center bg-danger">
										<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-prefix="fas" data-icon="times" role="img" viewBox="0 0 352 512" className="w-[11px]">
											<path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
											</path>
										</svg>
									</span>}
									{options.type === 'info' && <span className="rounded-full d-inline-flex w-[31px] h-[31px] align-items-center justify-content-center">
										<svg className="w-[35px]" enable-background="new 0 0 48 48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" fill="#2196f3" r="21" /><g fill="#fff"><path d="m22 22h4v11h-4z" /><circle cx="24" cy="16.5" r="2.5" /></g></svg>
									</span>}
								</div>
								<div className="ml-2">
									<div className="h-100 w-100 position-relative ">
										{isHTMLString(options.message) ? (
											<span className="text-base" dangerouslySetInnerHTML={{ __html: options.message }} />
										) : (
											<span className="text-base">{options.message}</span>
										)}
									</div>
								</div>
							</div>
							<span onClick={() => closeSnackbar(key)}>
								<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" className="d-flex rounded-full algin-items-center justify-content-center position-absolute w-[30px] h-[30px] right-[-35px] top-0 bg-light/30 pointer">
									<g id="Group_11134" data-name="Group 11134" transform="translate(-1268 -28)">
										<circle id="Ellipse_201" data-name="Ellipse 201" cx="17" cy="17" r="17" transform="translate(1268 28)" opacity="0.081">
										</circle>
										<g id="e-remove" transform="translate(1278.49 38.49)">
											<path id="Path_13784" data-name="Path 13784" d="M13.742,1.279a.9.9,0,0,0-1.3,0L7.51,6.208,2.581,1.279a.9.9,0,0,0-1.3,0,.9.9,0,0,0,0,1.3L6.208,7.51,1.279,12.44a.9.9,0,0,0,0,1.3.844.844,0,0,0,.651.279.844.844,0,0,0,.651-.279L7.51,8.813l4.929,4.929a.9.9,0,0,0,1.3,0,.9.9,0,0,0,0-1.3L8.813,7.51l4.929-4.929A.9.9,0,0,0,13.742,1.279Z" transform="translate(-1 -1)" fill="#fff">
											</path>
										</g>
									</g>
								</svg>
							</span>
						</div>
					</div>
				</div>
			</div>
		),
		...options,
	});
}

export const navigateTo = (to, params = {}) => function (e) {
	if (!to) {
		to = '/';
	}
	if (!to.startsWith('/')) {
		to = '/' + to;
	}
	e && e.preventDefault && e.preventDefault();
	this.props.history.push(to, params);
}

export async function readURL(files) {
	return new Promise(resolve => {
		if (files && files[0]) {
			let reader = new FileReader();
			reader.onload = e => resolve({
				data: e.target.result,
				size: files[0].size
			});
			reader.readAsDataURL(files[0]);
		} else {
			resolve(false);
		}
	})
}

export function setClassNameCondition(ifTrue, classTrue, classFalse, initClass = '') {
	return initClass + ' ' + (ifTrue ? classTrue : classFalse);
}

export function getUrl(pathname) {
	let { hostname, protocol, port } = window.location;
	let portString = '';
	if (port !== '80' && port !== '443' && port !== '') {
		portString = ':' + port;
	}
	return protocol + '//' + hostname + portString + '/' + pathname;
}

export function getJSONFromUrl() {
	try {
		let search = window.location.search.substring(1);
		let json = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
		let result = {};
		Object.keys(json).forEach(key => {
			result[decodeURIComponent(key)] = decodeURIComponent(json[key]);
		})
		return result;
	} catch (e) {
		return {};
	}
}

export function handleClickOutside({ target }) {
	Object.keys(this.refList).forEach(key => {
		let ref = this.refList[key];
		if (ref.current && !ref.current.contains(target)) {
			this.setState({ [key]: false })
		}
	})
}

export function betCondition(transaction) {
	if (transaction.bet_condition === 'up') {
		return 'Mua';
	}
	if (transaction.bet_condition === 'down') {
		return 'Bán';
	}
}

export async function getSocket() {
	if (window.socket) {
		return window.socket;
	}
	return new Promise(resolve => {
		let intervalCheckSocket = setInterval(() => {
			if (window.socket) {
				clearInterval(intervalCheckSocket);
				return resolve(window.socket);
			}
		}, 200);
	})
}

export function isDesktop() {
	return window.innerWidth > 1024;
}

export function isMobile() {
	return !isDesktop();
}

export function preventDefault(e) {
	e && e.preventDefault();
}

export function copyText(text) {
	navigator.clipboard.writeText(text)
		.then(() => {
			showNotification({ type: 'success', message: 'Đã sao chép vào bộ nhớ' });
		})
		.catch(e => {
			showNotification({ type: 'danger', message: e.message });
		})
}
